import React from 'react';
import {
  ONLINE_PAYMENTS,
  ORDER_TYPE_DELIVERY,
  PAYMENT,
  PRIMARY,
  SECONDARY,
} from '../../../constants';
import Button from '../../Button';
import { getCreditCard, isQrCode } from '../../../utils';
import { useAppDispatch, useAppSelector } from '../../../redux/hook';
import { showPaymentModal } from '../../../redux/actions';
import { addCustomerCard } from '../../../api';
import { getPaymentTypeLabel } from '../CartModal.services';
import { Stripe, StripeElement } from '@stripe/stripe-js';
import _ from 'lodash';

type PaymentTypeProps = {
  paymentTypes: any;
  stripe: Stripe;
  elements: StripeElement;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  handleCheckOrder: (card: any, paymentType: string) => Promise<void>;
  isUserAnonymous: boolean;
};

export default function PaymentType({
  paymentTypes,
  stripe,
  elements,
  setLoading,
  handleCheckOrder,
  isUserAnonymous,
}: PaymentTypeProps) {
  const dispatch = useAppDispatch();
  const { orderType } = useAppSelector((state) => state.pendingOrderReducer);
  const {
    user: { cards },
  } = useAppSelector((state) => state.userReducer);

  const onlineTypes = _.filter(paymentTypes, (type) =>
    ONLINE_PAYMENTS.includes(type)
  );

  const offlineTypes = _.filter(
    paymentTypes,
    (type) => !ONLINE_PAYMENTS.includes(type)
  );

  const displayButton = (paymentType: string) => {
    {
      let className = 'btn btn-block ';
      if (paymentType !== PAYMENT.TYPE_STRIPE) {
        className += 'btn-secondary';
      }
      return (
        <div className='row mb-2'>
          <div className='col'>
            <Button
              type={`${paymentType === PAYMENT.TYPE_STRIPE ? PRIMARY : SECONDARY
                }`}
              className={className}
              onClick={async () => {
                const card = getCreditCard();
                if (paymentType === PAYMENT.TYPE_STRIPE && !card) {
                  if (!isUserAnonymous) {
                    dispatch(showPaymentModal(true));
                  } else {
                    setLoading(true);
                    const card = await addCustomerCard(stripe, elements);
                    if (card) {
                      await handleCheckOrder(card, paymentType);
                    } else {
                      setLoading(false);
                    }
                  }
                } else {
                  await handleCheckOrder(card, paymentType);
                }
              }}
            >
              {paymentType === PAYMENT.TYPE_STRIPE &&
                !isQrCode() &&
                (_.isEmpty(cards) || !_.find(cards, (card) => card.selected))
                ? 'Ajouter une carte bancaire'
                : getPaymentTypeLabel(paymentType)}
            </Button>
          </div>
        </div>
      );
    }
  };

  return (
    <div>
      <p className='text-muted mb-2 label'> Modes de paiement</p>
      {onlineTypes.length > 0 && (
        <>
          <p className='mb-1 label'>Paiement en ligne:</p>
          {onlineTypes.map((paymentType: string) => displayButton(paymentType))}
        </>
      )}
      {offlineTypes.length > 0 && (
        <>
          <p className=' mb-1 label'>
            {orderType === ORDER_TYPE_DELIVERY
              ? 'Paiement à réception:'
              : 'Paiement sur place:'}
          </p>
          {offlineTypes.map((paymentType: string) =>
            displayButton(paymentType)
          )}
        </>
      )}
    </div>
  );
}
